import { createContext, useContext } from 'react';

const Context = createContext();

export const ProductProvider = Context.Provider;

export const useProduct = () => useContext(Context);
